import { render } from "./roles-permissions-modal.vue?vue&type=template&id=39393cf1"
import script from "./roles-permissions-modal.vue?vue&type=script&lang=js"
export * from "./roles-permissions-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__